import {
  Timestamp,
  collection,
  serverTimestamp,
  addDoc,
} from "firebase/firestore";
import { db } from "../config/firebase";

export const firestoreCollections = {
  customerProjects: "customerProjects",
  customers: "customers",
  merchantCategories: "merchantCategories",
  merchants: "merchants",
  projectsBids: "projectsBids",
  wishlistedMerchants: "wishlistedMerchants",
  merchantReviews: "merchantReviews",
  chats: "chats",
  payments: "payments",
  merchantWithdrawals: "merchantWithdrawals",
  supportTickets: "supportTickets",
  activityLogs: "activityLogs",
  coupons: "coupons",
};

export const accountType = {
  CUSTOMER: "CUSTOMER",
  MERCHANT: "MERCHANT",
  ADMIN: "ADMIN",
};

// take the syntax of coupon from firebase; and coupons can never be deleted and only few fields can be editable that we need to discuss, because we are storing coupon id in payment collection's doc and when we will later refer to the coupon using the id then there will be no track of what coupon name,condition,off was applied if the details are changed
// conclusion - validity and status can only be updated
export const couponType = {
  PROJECT: "PROJECT",
};
export const couponOffValidation = {
  PERCENTAGE: "PERCENTAGE",
  FLAT: "FLAT",
};
export const couponStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export const withdrawReqStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export const userIssueStatus = {
  RESOLVED: "RESOLVED",
  ACTIVE: "ACTIVE",
};

export const projectStatus = {
  ACTIVE: "ACTIVE",
  COMPLETE: "COMPLETE",
  POSTED: "POSTED",
  ADMIN_DECLINED: "ADMIN_DECLINED",
};

export const errorTypes = {
  FETCH_ERROR: "FETCH_ERROR",
  UPDATE_ERROR: "UPDATE_ERROR",
  NOT_FOUND: "NOT_FOUND",
};

export const merchAccountStatus = {
  PROFILE_NOT_ADDED: "PROFILE_NOT_ADDED", // unverified and not added profile
  PROFILE_UNDER_REVIEW: "PROFILE_UNDER_REVIEW", // profile added and is under review
  UNVERIFIED: "UNVERIFIED", // unverified and profile added
  ACTIVE: "ACTIVE", // verified
  TEMP_BLOCK: "TEMP_BLOCK", // verified and temporary block
  PERMANENT_BLOCK: "PERMANENT_BLOCK", // verified and permanent block
};

export const activityLogType = {
  PROFILE_UPDATED: "PROFILE_UPDATED",
  MERCH_PROFILE_DECLINED: "MERCH_PROFILE_DECLINED",
  MERCH_PROFILE_APPROVED: "MERCH_PROFILE_APPROVED",
  PROFILE_UNDER_REVIEW: "PROFILE_UNDER_REVIEW",
};

// export const projectStatus = {
//   ACTIVE: "ACTIVE",
//   COMPLETE: "COMPLETE",
//   POSTED: "POSTED",
//   ADMIN_DECLINED: "ADMIN_DECLINED",
// };

export const convertTimestampToDate = timestamp => {
  if (!timestamp) return null;

  let date;

  // Check if the timestamp is a Firebase Timestamp object with toDate method
  if (timestamp && typeof timestamp.toDate === "function") {
    date = timestamp.toDate(); // Convert Firestore Timestamp to JavaScript Date
  }
  // Check if it's a JavaScript timestamp (number)
  else if (typeof timestamp === "number") {
    date = new Date(timestamp); // Convert milliseconds to JavaScript Date
  }
  // If it's already a Date object
  else if (timestamp instanceof Date) {
    date = timestamp;
  }
  // If none of the above, return null
  else {
    console.warn("Invalid timestamp format:", timestamp);
    return null;
  }

  const day = date.getDate();
  const month = date.getMonth() + 1; // Months are 0-based, so adding 1
  const year = date.getFullYear().toString().substr(-2); // Extract the last 2 digits of the year

  // Pad single-digit day and month with leading zero if needed
  const formattedDay = day < 10 ? `0${day}` : day;
  const formattedMonth = month < 10 ? `0${month}` : month;

  return `${formattedDay}/${formattedMonth}/${year}`;
};

export const formatFirebaseTimestampForChat = timestamp => {
  if (!timestamp) return null;

  const formatDate = (date, format) => {
    const options = {
      year:
        date.getFullYear() !== new Date().getFullYear() ? "numeric" : undefined,
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };
    return new Intl.DateTimeFormat("en-US", options).format(date);
  };

  let date;

  // Check if the timestamp is a Firebase Timestamp object with toDate method
  if (timestamp && typeof timestamp.toDate === "function") {
    date = timestamp.toDate(); // Convert Firestore Timestamp to JavaScript Date
  }
  // Check if it's a JavaScript timestamp (number)
  else if (typeof timestamp === "number") {
    date = new Date(timestamp); // Convert milliseconds to JavaScript Date
  }
  // If it's already a Date object
  else if (timestamp instanceof Date) {
    date = timestamp;
  }
  // If none of the above, return null
  else {
    console.warn("Invalid timestamp format:", timestamp);
    return null;
  }

  return formatDate(date, "MMM D, yyyy, H:mm a");
};

export const convertToFirestoreTimestamp = dateString => {
  const date = new Date(dateString);
  return Timestamp.fromDate(date);
};

export const formatActivityMessage = activity => {
  switch (activity.activityLogType) {
    case activityLogType.PROFILE_UPDATED:
      if (activity.details?.changeDetails) {
        const changedFields = Object.keys(activity.details.changeDetails);
        if (changedFields.length > 0) {
          return `Merchant updated profile (${changedFields.length} field${
            changedFields.length > 1 ? "s" : ""
          } changed)`;
        }
      }
      return "Merchant updated the profile";

    case activityLogType.MERCH_PROFILE_DECLINED:
      return `Admin declined the profile`;

    case activityLogType.PROFILE_UNDER_REVIEW:
      return "Merchant submitted profile for review";

    default:
      return "Activity: " + activity.activityLogType;
  }
};

export const logUserActivity = async (
  accType,
  userId,
  activityLogType,
  details = {}
) => {
  const activity = {
    accType,
    userId,
    activityLogType,
    details,
    createdAt: serverTimestamp(),
  };
  try {
    await addDoc(collection(db, firestoreCollections.activityLogs), activity);
    console.log("Activity logged successfully.");
  } catch (error) {
    console.error("Error logging activity:", error);
    throw error;
  }
};
